import * as paymentActions from "../actionTypes/paymentSummaryActionTypes"

export interface IAccountBalanceResponse {
  currency: string;
  accountNo: string;
  accBalance: number;
  isAccountDetailsFetched: boolean;
}

export interface IPaymentSummaryResponse {
  amount: number;
  inrAmt: number;
  bankCharges: number;
  sourceTax: number;
  gst: number;
  totalAmt: number;
  rate: number;
  originalRate:number;
  currency: string;
  fccTax: number;
  commissionAmount: number;
  isPaymentDetailsFetched: boolean;
}

export interface PaymentState {
  accountCurrency: string;
  accountNo: string;
  accBalance: number;
  amount: number;
  inrAmt: number;
  bankCharges: number;
  sourceTax: number;
  gst: number;
  totalAmt: number;
  rate: number;
  originalRate:number;
  currency: string;
  fccTax: number;
  commissionAmount: number;
  isAccountDetailsFetched: boolean;
  isPaymentDetailsFetched: boolean;
  connect24Error: any;
}

const initialState: PaymentState = {
  accountCurrency: "",
  accountNo: "",
  accBalance: 0,
  amount: 0,
  inrAmt: 0,
  bankCharges: 0,
  sourceTax: 0,
  gst: 0,
  totalAmt: 0,
  rate: 0,
  originalRate:0,
  currency: "",
  fccTax: 0,
  commissionAmount: 0,
  isPaymentDetailsFetched: false,
  isAccountDetailsFetched: false,
  connect24Error: false
}

export const PaymentSummaryReducer = (
  state: PaymentState = initialState,
  action: paymentActions.PaymentAction
): PaymentState => {
  switch (action.type) {
    case paymentActions.GET_ACCOUNT_BALANCE_SUCCESS:
      return {
        ...state,
        accountCurrency: action.accountCurrency,
        accountNo: action.accountNo,
        accBalance: action.accBalance,
        isAccountDetailsFetched: true
      };
      case paymentActions.GET_ACCOUNT_BALANCE_FAILURE:
      return {
        ...state,
        connect24Error: true
      };
    case paymentActions.GET_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        amount: action.amount,
        inrAmt: action.inrAmt,
        bankCharges: action.bankCharges,
        sourceTax: action.sourceTax,
        gst: action.gst,
        totalAmt: action.totalAmt,
        rate: action.rate,
        originalRate: action.originalRate,
        currency: action.currency,
        fccTax: action.fccTax,
        commissionAmount: action.commissionAmount,
        isPaymentDetailsFetched: true
      };
    case paymentActions.GET_TRANSACTION_SUMMARY_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
